// react
import React from "react";

import { SizeProp } from "@fortawesome/fontawesome-svg-core";
import { IconDefinition } from "@fortawesome/pro-regular-svg-icons";

// components
import CompatibilityWrapper from "./compatibility";

export interface IconCompatibilityProps {
	/**
	 * Additional classes to add to the icon
	 */
	className?: string;
	/**
	 * use 'small' or 'regular' for the new icon component
	 */
	size?: string | number | SizeProp;
	/**
	 * Font Awesome Icon requried for new component
	 */
	icon?: IconDefinition;
	/**
	 * name is only used for compatibility with the old icon component
	 * don't pass in type if you're using the new icon component
	 */
	name?: any;
	/**
	 * type is only used for compatibility with the old icon component
	 * don't pass in type if you're using the new icon component
	 */
	type?: "awesome" | "fontawesome" | "fa5" | "material";

	/**
	 * additional styles to apply to the icon
	 */
	style?: React.CSSProperties;

	"data-testid"?: string;
}

const Icon = (props: IconCompatibilityProps) => {
	return <CompatibilityWrapper {...props} />;
};
export default Icon;
